
























































import {
  defineComponent,
  ref,
  reactive,
  watch,
  SetupContext,
} from '@vue/composition-api'

import { IReceipt } from '@/types/receipt'

type Props = {
  receipt: IReceipt
  height: number
}

export default defineComponent({
  name: 'ReceiptView',
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: Number,
      default: 100,
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, content: SetupContext) {
    const showImg = ref(true)
    const showOriginal = ref(true)
    const imgSize = ref(100)

    const toggleShowImg = () => {
      showImg.value = !showImg.value
    }
    const toggleShowOriginal = () => {
      showOriginal.value = !showOriginal.value
    }

    // Drag definition
    const receiptPos = reactive({
      top: 0,
      left: 0,
    })
    const prevPos = reactive({
      top: 0,
      left: 0,
    })
    const isMouseDown = ref(false)
    const receiptRef = ref<HTMLImageElement>()
    const onMouseDown = (event: MouseEvent) => {
      isMouseDown.value = true
      prevPos.left = event.offsetX
      prevPos.top = event.offsetY
    }
    const onMouseMove = (event: MouseEvent) => {
      if (!receiptRef.value || !isMouseDown.value) return
      event.preventDefault()
      const diffX = event.offsetX - prevPos.left
      const diffY = event.offsetY - prevPos.top
      receiptPos.top = receiptPos.top + diffY
      receiptPos.left = receiptPos.left + diffX
    }
    const onMouseUp = () => {
      isMouseDown.value = false
    }

    const resetImgPos = () => {
      imgSize.value = 100
      receiptPos.top = 0
      receiptPos.left = 0
    }

    watch(
      () => props.receipt.id,
      () => {
        showImg.value = true
        showOriginal.value = true
        resetImgPos()
      },
    )

    const zoomOut = () => {
      const newSize = imgSize.value * 0.8
      imgSize.value = newSize < 100 ? 100 : newSize
    }

    const close = () => {
      content.emit('update:receipt', null)
    }

    return {
      showImg,
      showOriginal,
      toggleShowImg,
      toggleShowOriginal,
      receiptPos,
      onMouseDown,
      onMouseMove,
      onMouseUp,
      receiptRef,
      imgSize,
      zoomOut,
      resetImgPos,
      close,
    }
  },
})
